import { IconCalendarTime, IconTrash } from '@tabler/icons-react'
import { Dayjs } from 'dayjs'
import { ReactNode } from 'react'

import { AstraButton, AstraCollapsibleCard, AstraIcon, AstraParagraph, DATE_TEMPLATES, format, subtract } from '~/astra'

type ProfileCollapsibleCardProps = {
    title: string
    activeFrom?: Dayjs | null
    nextProfileActiveFrom?: Dayjs | null
    defaultOpen?: boolean
    onRemove: () => void
    children: ReactNode
}

export const ProfileCollapsibleCard = ({ title, activeFrom, nextProfileActiveFrom, defaultOpen, onRemove, children }: ProfileCollapsibleCardProps) => (
    <AstraCollapsibleCard
        header={
            <div className="flex items-center gap-2">
                <AstraIcon size="large" backgroundColor="bg-neutral-rest" backgroundShape="rounded" icon={IconCalendarTime} />
                <AstraParagraph weight="medium">{title}</AstraParagraph>
                {activeFrom && (
                    <AstraParagraph weight="regular" className="text-muted">
                        Fra {format(activeFrom, DATE_TEMPLATES.norwegianDate)}
                        {nextProfileActiveFrom && ` til ${format(subtract(nextProfileActiveFrom, 1, 'day'), DATE_TEMPLATES.norwegianDate)}`}
                    </AstraParagraph>
                )}
            </div>
        }
        defaultOpen={defaultOpen}
    >
        <div className="flex flex-col gap-4">
            {children}
            <AstraButton type="button" variant="critical-secondary" label="Fjern fremtidig profil" icon={<AstraIcon icon={IconTrash} />} onClick={onRemove} />
        </div>
    </AstraCollapsibleCard>
)
